import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flex: 1},
  nameText: {
    textAlign: 'left',
  },
  nameContainer: {marginLeft: 10},
  subContainer: {justifyContent: 'flex-start'},
  leftContainer: {justifyContent: 'flex-end'},
});
